type Props = {
  id: string;
};

export const useElementId = ({ id }: Props) => `card-${id}`;
